import { MenuItem, Select, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const BasicInfoSection = () => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_register.basic_info.title")}
      rows={[
        {
          label: t("promotion_register.basic_info.form.name.label"),
          required: true,
          children: (
            <TextField
              size="small"
              placeholder={t("promotion_register.basic_info.form.name.placeholder")}
              sx={{ width: "50%" }}
            />
          ),
        },
        {
          label: t("promotion_register.basic_info.form.type.label"),
          note: t("promotion_register.basic_info.form.type.note"),
          required: true,
          children: (
            <Select size="small" sx={{ width: "50%" }}>
              <MenuItem value="type1">
                {t("promotion_register.basic_info.form.type.type1")}
              </MenuItem>
              <MenuItem value="type2">
                {t("promotion_register.basic_info.form.type.type2")}
              </MenuItem>
            </Select>
          ),
        },
        {
          label: t("promotion_register.basic_info.form.description.label"),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t(
                "promotion_register.basic_info.form.description.placeholder",
              )}
              fullWidth
            />
          ),
        },
        {
          label: t("promotion_register.basic_info.form.template.label"),
          required: true,
          children: (
            <Select size="small" sx={{ width: "50%" }}>
              <MenuItem value="yes">
                {t("promotion_register.basic_info.form.template.yes")}
              </MenuItem>
              <MenuItem value="no">
                {t("promotion_register.basic_info.form.template.no")}
              </MenuItem>
            </Select>
          ),
        },
      ]}
    />
  );
};

export default BasicInfoSection;
